import React, { useState } from "react";
import { toast } from "react-toastify";

import { formRegEx, formRegExReplacer, imageUrl } from "../Config/apiUrl";
import ModalSkeleton from "./ModalSkeleton";
import { green } from "@material-ui/core/colors";

const AddAndEditServicesModal = ({
  open,
  setOpen,
  data,
  isLoading,
  handleSubmit,
}) => {
  const [name, setName] = useState(data?.name || "");
  const [minPrice, setMinPrice] = useState(data?.minPrice || "");

  // IMAGE / vIDEO
  const [selectedImage, setSelectedImage] = useState(data?.icon || undefined);
  const [selectedImageFile, setSelectedImageFile] = useState(null);

  //   btnClickHandler
  const btnClickHandler = (e) => {
    e.preventDefault();
    const params = {
      name,
      minPrice,
      ...(selectedImageFile && { icon: selectedImageFile }),
    };

    // validate
    for (let key in params)
      if (params[key] === "")
        return toast.warn(
          `${key.replace(formRegEx, formRegExReplacer)} is required.`
        );

    // validateImage
    if (!selectedImageFile && !selectedImage)
      return toast.warn(`Image is required.`);

    handleSubmit(params);
  };

  //   handleSelectImage
  const handleSelectImage = (event) => {
    setSelectedImageFile(event.target.files[0]);
    let reader = new FileReader();

    reader.onload = (event) => {
      setSelectedImage(event.target.result);

      var media = new Audio(reader.result);
      media.onloadedmetadata = function () {
        // setVideoDuration(millisToMinutesAndSeconds(media.duration * 1000));
      };
    };
    reader.readAsDataURL(event.target.files[0]);
  };

  return (
    <ModalSkeleton open={open} setOpen={setOpen}>
      <form className="login100-form validate-form">
        <span className="login100-form-title text-left text-color pb-4">
          {data ? "Edit" : "Add"} Service
        </span>

        {/* Name */}
        <div>
          <label>Service Name</label>
          <input
            className="add-evidence-modal-input full"
            type="text"
            placeholder="Name Here"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>

        {/* Min Price */}
        <div className="mt-3">
          <label>Min Price</label>
          <input
            className="add-evidence-modal-input full"
            type="number"
            placeholder="Min  Price Here"
            value={minPrice}
            onChange={(e) => {
              setMinPrice(e.target.value);
            }}
          />
        </div>

        {/* Video */}
        <div class="form-group" className="seo__imagePicker mt-3">
          <input
            type="file"
            accept="image/png, image/gif, image/jpeg"
            name="uploadfile"
            id="img"
            style={{
              display: "none",
            }}
            onChange={(event) => {
              handleSelectImage(event);
            }}
          />
          <label for="exampleInputEmail1">Select Image</label>
          <label
            for="img"
            className="btn btn-primary btn-lg btn-block"
            style={{
              backgroundColor: green[500],
            }}
            onChange={(e) => {
              // console.log(e.target.files[0]);
            }}
          >
            {selectedImage ? "Change selection" : "Pick an Image"}
          </label>
        </div>

        {/* Shoe Image */}
        {selectedImage && (
          <div className="d-flex align-items-center justify-content-center w-100">
            <img
              src={selectedImageFile ? selectedImage : imageUrl(selectedImage)}
              alt="selectedImage"
              className="w-50 mt-3"
            />
          </div>
        )}

        {/* btn */}
        <div className="container-login100-form-btn mt-4">
          <div className="wrap-login100-form-btn">
            <div className="login100-form-bgbtn"></div>
            <button
              disabled={isLoading}
              className="login100-form-btn"
              onClick={btnClickHandler}
            >
              {isLoading ? "Please Wait..." : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </ModalSkeleton>
  );
};

export default AddAndEditServicesModal;
